<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: whaoo
 * @Date: 2023-10-10 09:26:28
 * @LastEditors: whaoo
 * @LastEditTime: 2024-05-20 10:44:19
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
@import url('./assets/style/commo.css');

</style>



// WEBPACK FOOTER //
// src/App.vue